import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  communityId: string;
  data: FieldValues
}

const mutateAddAdhocJob = async ({ data, communityId }: mutateProps) => {
  return await axiosAuth.post(
    `${DISTRIBUTION_JOBS_API(communityId)}/adhoc`,
    data
  );
};

const useAddAdhocJobMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddAdhocJob,
    ...queryParams,
  });

export default useAddAdhocJobMutation;
